import {TextArea} from '@/components/commons/textarea/TextArea'
import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {PencilLineIcon, Trash01Icon} from '@/components/ui/icon/Icon'
import {AgendaEventFieldsSchema} from '@/features/agenda/formSchemas'
import {useToggle} from '@/hooks/useToggle'
import {useTranslation} from '@/translations/i18n'
import {useEffect} from 'react'
import {useFormContext, useWatch} from 'react-hook-form'
import {z} from 'zod'

const AgendaEventNotesFieldSchema = AgendaEventFieldsSchema.pick({
    note: true
})
type AgendaEventNotesFieldSchema = z.infer<typeof AgendaEventNotesFieldSchema>

export const AgendaEventNotesField = () => {
    const {t} = useTranslation()
    const {control, register, setValue} = useFormContext<AgendaEventNotesFieldSchema>()
    const note = useWatch({control, name: 'note'})
    const {isActive, on, off, toggle} = useToggle(!!note)

    const handleRemoveNotes = () => {
        setValue('note', '')
        off()
    }

    useEffect(() => {
        if (note) {
            on()
        } else {
            off()
        }
    }, [note])

    return (
        <Flexbox direction="column" gap={2} fullWidth>
            <Flexbox fullWidth align="center" justify="space-between">
                <Button variant="ghost" shape="text" size="sm" onClick={toggle}>
                    <PencilLineIcon />
                    {t('commons:notes')}
                </Button>
                {note && (
                    <Button variant="ghost" shape="text" size="sm" onClick={handleRemoveNotes}>
                        <Trash01Icon />
                        {t('agenda:remove_notes')}
                    </Button>
                )}
            </Flexbox>
            {isActive && (
                <TextArea
                    placeholder={t('agenda:add_notes')}
                    helpText={t('agenda:add_notes_placeholder')}
                    {...register('note')}
                />
            )}
        </Flexbox>
    )
}
